module.exports = __webpack_public_path__ + "resource/static/img/icon14@1.5x.76434b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img1/icon14@1.5x.png
// module id = /pCJ
// module chunks = 1